import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { useLanguage } from '../LanguageContext';
import { netCharitableFromGross } from '../utils/contributionSplit';
import { formatUsd } from '../utils/formatMoney';

export default function PublicTotalsSection() {
  const { t } = useLanguage();
  const [totals, setTotals] = useState({
    totalCharitableNet: 0,
    totalCapitalFund: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const data = await api.getContributionTotals();
        if (!cancelled) {
          setTotals({
            totalCharitableNet:
              data.totalCharitableNet ??
              netCharitableFromGross(data.totalDonations ?? 0),
            totalCapitalFund: data.totalCapitalFund ?? data.totalInvestments ?? 0,
          });
        }
      } catch {
        /* keep zeros */
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="section section--totals" id="totals" aria-labelledby="totals-heading">
      <div className="section__head">
        <h2 id="totals-heading">{t('contributions.totalsTitle')}</h2>
        <p className="section__sub">{t('contributions.totalsSub')}</p>
      </div>

      <div className="public-totals">
        <article className="public-total-card public-total-card--donation">
          <span className="public-total-card__label">{t('contributions.totalCharitableNet')}</span>
          <span className="public-total-card__value" dir="ltr">
            {loading ? '—' : formatUsd(totals.totalCharitableNet)}
          </span>
          <span className="public-total-card__hint">{t('contributions.totalCharitableHint')}</span>
        </article>
        <article className="public-total-card public-total-card--investment">
          <span className="public-total-card__label">{t('contributions.totalCapitalFund')}</span>
          <span className="public-total-card__value" dir="ltr">
            {loading ? '—' : formatUsd(totals.totalCapitalFund)}
          </span>
          <span className="public-total-card__hint">{t('contributions.totalCapitalHint')}</span>
        </article>
      </div>
    </section>
  );
}
